import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ShopGameRoundOptionSetting } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopGameRoundOptionSetting';

import { callShopGameRoundOptionSetting, callEditShopGameRoundOptionSetting } from 'network/apis/shop/shopGameRoundOptionSetting';

// 매장 게임 라운드 옵션 정보 조회 사가 함수
function* loadShopGameRoundOptionSettingRequestSaga() {
  try {
    const manager = yield select((state) => state.manager);

    const response = yield call(callShopGameRoundOptionSetting, manager.manager.shopGuid);

    yield put(actions.loadShopGameRoundOptionSettingRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.loadShopGameRoundOptionSettingRequestFailure(error.message));
  }
}

// 매장 게임 라운드 옵션 정보 조회 사가 함수
function* editShopGameRoundOptionSettingRequestSaga() {
  try {
    const manager = yield select((state) => state.manager);
    const shopGameRoundOptionSetting = yield select((state) => state.shopGameRoundOptionSetting);
    const data = {
      concede: shopGameRoundOptionSetting.data.concede,
      holeCupLocation: shopGameRoundOptionSetting.data.holeCupLocation,
      mulliganCount: shopGameRoundOptionSetting.data.mulliganCount,
      useSwingPlate: shopGameRoundOptionSetting.data.useSwingPlate,
      distanceUnit: shopGameRoundOptionSetting.data.distanceUnit,
      greenLocation: shopGameRoundOptionSetting.data.greenLocation,
      greenSpeed: shopGameRoundOptionSetting.data.greenSpeed,
      greenHardness: shopGameRoundOptionSetting.data.greenHardness == null ? 0 : shopGameRoundOptionSetting.data.greenHardness,
      windSpeed: shopGameRoundOptionSetting.data.windSpeed,
      // puttingLine: shopGameRoundOptionSetting.data.puttingLine,
      puttingLine: -1,
      isBestVideo: shopGameRoundOptionSetting.data.isBestVideo,
      // isContinuePutting: shopGameRoundOptionSetting.data.isContinuePutting,
      isCaddyVoice: shopGameRoundOptionSetting.data.isCaddyVoice,
      isNoPuttMode: shopGameRoundOptionSetting.data.isNoPuttMode,
      isUseObHazardTee: shopGameRoundOptionSetting.data.isUseObHazardTee,
      shotInfoLocation: shopGameRoundOptionSetting.data.shotInfoLocation,
      isUseGuideDistance: shopGameRoundOptionSetting.data.isUseGuideDistance,
      maxScoreFactor: shopGameRoundOptionSetting.data.maxScoreFactor,
    };
    const response = yield call(callEditShopGameRoundOptionSetting, manager.manager.shopGuid, data);

    yield put(actions.editShopGameRoundOptionSettingRequestSuccess(response.data));

    alert('게임 옵션 수정이 완료되었습니다.');
  } catch (error) {
    yield put(actions.editShopGameRoundOptionSettingRequestFailure(error.message));
  }
}

// Sign-In Sagas
export default function* root() {
  yield all([
    takeLatest(ShopGameRoundOptionSetting.LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST, loadShopGameRoundOptionSettingRequestSaga),
    takeLatest(ShopGameRoundOptionSetting.EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST, editShopGameRoundOptionSettingRequestSaga),
  ]);
}
